import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  WAREHOUSES(state, gycwarehouse) {
    state.cached = gycwarehouse
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchWarehouses(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/manager/ecommerces/warehouses/${query}`).then((response) => {
      const request = response.data
      context.commit('WAREHOUSES', request)
      return request
    })
  },

  fetchWarehouseOptions(context, query) {
    query = query || ''
    return axios.options(`${serverUrl}/manager/warehouses/${query}`).then((response) => {
      return response.data
    })
  },

  fetchWarehouseDetail(context, payload) {
    return axios.get(`${serverUrl}/manager/ecommerces/${payload.ecommerce_id}/warehouses/${payload.id}/`).then((response) => {
      return response.data
    })
  },

  createUpdateWarehouse(context, payload) {
    let promise = null
    if (payload.data.id){
      promise =  axios.put(`${serverUrl}/manager/ecommerces/${payload.ecommerce_id}/warehouses/${payload.data.id}/`, payload.data)
    }else {
      promise =  axios.post(`${serverUrl}/manager/ecommerces/${payload.ecommerce_id}/warehouses/`, payload.data)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
  deleteWarehouse(context, payload) {
    let promise = null
    promise =  axios.delete(`${serverUrl}/manager/ecommerces/${payload.ecommerce_id}/warehouses/${payload.warehouse_id}`)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  }
}